import { useEffect, Component } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import BrandStatement from "@/components/BrandStatement";
import Markets from "@/components/Markets";
import WhyTavonx from "@/components/WhyTavonx";
import Ecosystem from "@/components/Ecosystem";
import TokenSection from "@/components/TokenSection";
import Tokenomics from "@/components/Tokenomics";
import UxtExplainer from "@/components/UxtExplainer";
import VestingTimeline from "@/components/VestingTimeline";
import HowItWorks from "@/components/HowItWorks";
import PlatformShowcase from "@/components/PlatformShowcase";
import Security from "@/components/Security";
import GlobalSection from "@/components/GlobalSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import LaunchModalProvider from "@/components/LaunchModal";

const NOISE = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='160' height='160' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E")`;

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-void text-slate-300">
                    Something went wrong — please reload the page.
                </div>
            );
        }
        return this.props.children;
    }
}

export default function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <LaunchModalProvider>
                <div className="relative min-h-screen bg-void font-sans text-silver">
                    <div
                        aria-hidden="true"
                        className="pointer-events-none fixed inset-0 z-[90] opacity-[0.035] mix-blend-overlay"
                        style={{ backgroundImage: NOISE }}
                    />
                    <Navbar />
                    <main>
                        <Hero />
                        <Marquee />
                        <BrandStatement />
                        <Markets />
                        <WhyTavonx />
                        <Ecosystem />
                        <TokenSection />
                        <Tokenomics />
                        <UxtExplainer />
                        <VestingTimeline />
                        <HowItWorks />
                        <PlatformShowcase />
                        <Security />
                        <GlobalSection />
                        <FinalCTA />
                    </main>
                    <Footer />
                </div>
            </LaunchModalProvider>
        </ErrorBoundary>
    );
}
